import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { ContextT } from "./DataContext";
import { Login } from "./Login";
import classes from "./Terminal.module.css";
import TextAnimation from "./TextAnimation";
import { logoText } from "./logo";

export const Terminal = forwardRef((props, ref) => {
  const { username, setUsername } = props;
  const { openTerminal, setOpenTerminal } = props;
  const { commandsHistory, setCommandsHistory } = props;
  const { openLogin, setOpenLogin } = props;
  const { history = [], commands = {}, setHistory } = props;
  const inputRef = useRef();
  const [input, setInputValue] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const { directory, setCommand, setFile, setEdit } = useContext(ContextT);

  const [animationFinished, setAnimationFinished] = useState(false);

  useEffect(() => {
    if (inputRef?.current) {
      inputRef?.current.focus();
    }
  });

  const focusInput = useCallback(() => {
    if (inputRef?.current) {
      inputRef?.current.focus();
    }
  }, []);

  const handleInputChange = useCallback((e) => {
    setInputValue(e.target.value);
  }, []);

  const handleInputKeyDown = useCallback(
    async (e) => {
      if (e.key === "Enter") {
        const inputCommand = input.toLowerCase().trim();
        const commandParts = inputCommand.split(" ");

        const commandName = commandParts[0];
        const commandArgs = commandParts.slice(1);
        if (commandArgs[0] !== "" && commandArgs[0] !== undefined) {
          commandArgs[0] = commandArgs[0].replace("/", "").replace("\\", "");
        }

        const commandToExecute = commands?.[commandName];

        if (commandName === "cd" && commandArgs[0].length >= 2) {
          setCommand(commandArgs[0]);
          sessionStorage.setItem("command", commandArgs[0]);
        }

        if (commandName === "file" && commandArgs[0].length >= 2) {
          setFile(commandArgs[0]);
          sessionStorage.setItem("file", commandArgs[0]);
        }

        if (commandName === "edit" && commandArgs[0].length >= 2) {
          setEdit(commandArgs[0]);
          sessionStorage.setItem("edit", commandArgs[0]);
        }

        if (commandName === "new" && commandArgs[0].length >= 2) {
          sessionStorage.setItem("new", commandArgs[0]);
        }

        if (commandName === "delete" && commandArgs[0].length >= 2) {
          sessionStorage.setItem("delete", commandArgs[0]);
        }

        if (
          commandName === "rename" &&
          commandArgs[0].length >= 2 &&
          commandArgs[1].length >= 2
        ) {
          sessionStorage.setItem("rename", commandArgs[0]);
          sessionStorage.setItem("newname", commandArgs[1]);
        }

        if (commandToExecute) {
          commandToExecute();

          setInputValue("");
          const newCommands = [...commandsHistory, inputCommand];
          console.log(newCommands);
          if (newCommands) {
            setCommandsHistory(newCommands);
          }
        }
      }
    },
    [input, commands, setCommand, commandsHistory, setCommandsHistory]
  );

  useEffect(() => {
    const handleKeyUp = (event) => {
      if (event.key === "ArrowUp") {
        setCurrentIndex((prevIndex) => {
          const newCurrentIndex = Math.min(
            prevIndex + 1,
            commandsHistory.length - 1
          );

          const lastCommand = commandsHistory[newCurrentIndex];
          setInputValue(lastCommand || "");
          return newCurrentIndex;
        });
      } else if (event.key === "ArrowDown") {
        setCurrentIndex((prevIndex) => {
          const newCurrentIndex = Math.max(prevIndex - 1, 0);
          const lastCommand = commandsHistory[newCurrentIndex];
          setInputValue(lastCommand || "");
          return newCurrentIndex;
        });
      }
    };

    window.addEventListener("keyup", handleKeyUp);
    return () => window.removeEventListener("keyup", handleKeyUp);
  }, [commandsHistory]);

  const handleAnimationFinish = () => {
    setAnimationFinished(true);
  };

  useEffect(() => {
    setOpenLogin(0);
    setOpenTerminal(false);
    setHistory([]);
  }, []);

  useEffect(() => {
    if (animationFinished) {
      setOpenLogin(1);
    }
  }, [animationFinished]);

  return (
    <>
      <div className={classes.scanlines}></div>
      <div className={classes["refresh-line"]}></div>
      <div className={classes.terminal} ref={ref} onClick={focusInput}>
        <TextAnimation
          texts={logoText}
          onFinishAnimation={handleAnimationFinish}
        />
        {history.map((line, index) => (
          <div
            className={classes.terminalLine}
            key={`terminal-line-${index}-${line}`}
          >
            {line}
          </div>
        ))}
        {openTerminal && (
          <>
            <div className={classes.terminalPrompt}>
              <div className={classes.terminalPromptLabel}>
                {username + `>`}
              </div>
              <div className={classes.terminalPromptRoot}>root/</div>
              {directory !== "" && directory != null && (
                <div className={classes.terminalPromptDirectory}>
                  {directory + `/`}
                </div>
              )}

              <div className={classes.terminalPromptInput}>
                <input
                  type="text"
                  value={input}
                  onKeyDown={handleInputKeyDown}
                  onChange={handleInputChange}
                  ref={inputRef}
                />
              </div>
            </div>
          </>
        )}
        {(openLogin === 1 || openLogin === 2) && (
          <Login
            openTerminal={openTerminal}
            setOpenTerminal={setOpenTerminal}
            openLogin={openLogin}
            setOpenLogin={setOpenLogin}
            username={username}
            setUsername={setUsername}
          />
        )}
      </div>
    </>
  );
});
